import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';

const SearchFilterBar = ({ 
  searchQuery, 
  onSearchChange, 
  orderFilter, 
  onOrderFilterChange,
  spendingFilter,
  onSpendingFilterChange,
  onReset
}) => {
  const orderFilterOptions = [
    { value: 'all', label: '전체' },
    { value: 'high', label: '10건 이상' },
    { value: 'medium', label: '5-9건' },
    { value: 'low', label: '1-4건' },
    { value: 'none', label: '주문 없음' }
  ];

  const spendingFilterOptions = [
    { value: 'all', label: '전체' },
    { value: 'vip', label: '50,000원 이상' },
    { value: 'high', label: '30,000-49,999원' },
    { value: 'medium', label: '10,000-29,999원' },
    { value: 'low', label: '10,000원 미만' }
  ];

  return (
    <div className="rounded-lg bg-card p-4 shadow-card">
      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
        <Input
          type="search"
          placeholder="이름 또는 전화번호 검색"
          value={searchQuery}
          onChange={(e) => onSearchChange(e?.target?.value)}
          className="bg-muted"
        />
        
        <Select
          options={orderFilterOptions}
          value={orderFilter}
          onChange={onOrderFilterChange}
          placeholder="주문 횟수"
        />
        
        <Select
          options={spendingFilterOptions}
          value={spendingFilter}
          onChange={onSpendingFilterChange}
          placeholder="결제 금액"
        />
        
        <div className="flex space-x-2">
          <Button
            variant="outline"
            iconName="RotateCcw"
            onClick={onReset}
            fullWidth
          >
            초기화
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SearchFilterBar;